export const localeConstants = {
    CHANGE: 'LOCALE_CHANGE',
};

export const twitterConstants = {
    CHANGE_VISIBILITY: 'CHANGE_TWITTER_TIMELINE_VISIBILITY',
};



// WEBPACK FOOTER //
// ./src/_constants/general.constants.js